import React, { useState, useEffect } from "react";
import { motion, AnimatePresence  } from "framer-motion";
const LOGO_SRC = "/img/uctc-head-logo.png";
import axios from "axios";

export default function Bte({ 
  accent = "#115e32",
  pageTitle = "Bachelor of Science in Textile Engineering | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	
	const [openSection, setOpenSection] = useState("overview");
	const [courses, setCourses] = useState({});
	const [loadingCourses, setLoadingCourses] = useState(false);
	const [error, setError] = useState(null);
	const [selectedSemester, setSelectedSemester] = useState("Semester Number: 1");
	
	const coursePost = async () => {
		setLoadingCourses(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"16",
				programme_id:"1",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/program-syllabus", payload);
			console.log();
			setCourses(response.data);
			
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoadingCourses(false);
		}
	};
	useEffect(() => {
		coursePost();		
	}, []);
	const toggle = (key) => setOpenSection((s) => (s === key ? "" : key));


	const gold = "text-amber-700";
  return (
	<>
    <section className="relative flex items-center justify-center min-h-screen bg-gradient-to-b from-[#6BCCF2] to-teal-50 text-[#014864] overflow-hidden">
      <div className="w-full max-w-7xl px-6 md:px-12 flex flex-col md:flex-row items-center gap-12">
        {/* Left Column */}
        <div className="flex flex-col items-start md:items-start gap-4 text-left md:w-[65%]">
          <div className="w-full h-40 md:w-48 md:h-48 rounded-2xl flex items-center justify-center bg-gray-100/60 backdrop-blur-md shadow-lg">
            <img
              src="/img/logo.png"
              alt="UCTC logo"
              className="w-[85%] h-[85%] object-contain"
            />
          </div>
          <p className="text-[#014864] font-bold tracking-widest text-xl md:text-2xl">
            UNIVERSITY OF CREATIVE TECHNOLOGY CHITTAGONG
          </p>
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight">
             Bachelor of Science in Textile Engineering
            <br />
            <span className="text-[#b88f18] font-bold opacity-85">
              Through Innovation & Adoption of Technology
            </span>
          </h1>
		   <p className="mt-1 text-amber-700 font-medium">School of Sciene and Engineering · Bahaddarhat Campus · Undergraduate (BTE)</p>
           <div className="mt-3 flex gap-3">
              <span className="px-3 py-1 rounded-full bg-amber-100 text-[#014864] font-semibold">Credits: 154</span>
              <span className="px-3 py-1 rounded-full bg-amber-100 text-[#014864] font-semibold">Start: January, July</span>
              <span className="px-3 py-1 rounded-full bg-amber-100 text-[#014864] font-semibold">Mode: On Campus</span>
            </div>
          <div className="flex gap-4 mt-4">
            <a
              href="/apply-online"
              className="px-5 py-3 rounded-lg bg-gradient-to-r from-[#014864] to-[#6f6016] text-white font-semibold shadow-lg hover:scale-105 transition"
            >
              Apply Now
            </a>
            <a
              href="#about"
              className="px-5 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
            >
              Learn More
            </a>
          </div>
        </div>

        {/* Right Column with Animated SVG */}
        <div className="hidden lg:block flex-1 w-full h-[400px] md:h-[500px]">
          <motion.svg
            viewBox="0 0 1100 600"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
          >
            <defs>
              <linearGradient id="g1" x1="0" x2="1" y1="0" y2="1">
                <stop offset="0%" stopColor="#e0f2f1" />
                <stop offset="100%" stopColor="#b2dfdb" />
              </linearGradient>
              <linearGradient id="gold" x1="0" x2="1">
                <stop offset="0%" stopColor="#b88f18" />
                <stop offset="100%" stopColor="#014864" />
              </linearGradient>
            </defs>

            {/* Animated Blob */}
            <motion.path
              d="M20,300 C60,120 260,20 460,80 C760,160 840,420 560,460 C380,490 160,420 20,300z"
              fill="url(#g1)"
              animate={{
                d: [
                  "M20,300 C60,120 260,20 460,80 C760,160 840,420 560,460 C380,490 160,420 20,300z",
                  "M10,320 C120,100 260,40 520,100 C780,170 820,420 560,480 C360,510 140,430 10,320z",
                  "M20,300 C60,120 260,20 460,80 C760,160 840,420 560,460 C380,490 160,420 20,300z",
                ],
              }}
              transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
            />

            {/* Floating Dots */}
            <motion.circle cx="120" cy="40" r="10" fill="#a5d6a7" animate={{ cy: [40, 20, 40] }} transition={{ duration: 5, repeat: Infinity }} />
            <motion.circle cx="40" cy="-10" r="6" fill="#80cbc4" animate={{ cy: [-10, 10, -10] }} transition={{ duration: 3.6, repeat: Infinity }} />
            <motion.circle cx="-80" cy="-20" r="8" fill="#4db6ac" animate={{ cy: [-20, -40, -20] }} transition={{ duration: 4.5, repeat: Infinity }} />

            {/* Decorative line */}
            <motion.rect
              x="60"
              y="520"
              height="8"
              rx="4"
              fill="url(#gold)"
              initial={{ width: 0 }}
              animate={{ width: 420 }}
              transition={{ duration: 2, ease: "easeOut" }}
            />

            {/* Badge */}
            <g transform="translate(680,480)" opacity="0.95">
              <rect
                width="300"
                height="60"
                rx="12"
                fill="rgba(0,0,0,0.02)"
                stroke="rgba(0,0,0,0.05)"
              />
              <text
                x="18"
                y="36"
                fontFamily="Inter, Arial"
                fontSize="26"
                fill="#014864"
                fontWeight="700"
              >
                Innovation · Creativity · Change
              </text>
            </g>
          </motion.svg>
        </div>
      </div>
    </section>

    <div className="min-h-screen bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF] p-6">
      <div className="max-w-6xl mx-auto">
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Left column: program card + fees */}
          <div className="space-y-4">
            <motion.div
              layout
              className="rounded-2xl bg-white/80 p-5 shadow-lg border border-amber-100"
            >
              <h3 className="text-xl font-bold text-[#014864]">Program Information</h3>
              <p className="mt-2 text-sm text-gray-700">
                Program: <span className="font-semibold">BTE</span>
                <br /> Campus: <span className="font-semibold">Chittagong</span>
                <br /> Level: <span className="font-semibold">Undergraduate</span>
                <br /> Semester: <span className="font-semibold">January, July</span>
                <br /> Method: <span className="font-semibold">Lectures, Seminars</span>
              </p>
              <div className="mt-4 flex gap-2">
                <button onClick={() => toggle("fees")} className="px-3 py-2 rounded-lg bg-[#014864] text-white font-semibold">View Fees</button>
                <button onClick={() => toggle("structure")} className="px-3 py-2 rounded-lg border border-amber-300 text-[#014864] font-semibold">Course Structure</button>
              </div>
            </motion.div>

            <AnimatePresence>
              {openSection === "fees" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 6 }}
                  transition={{ duration: 0.35 }}
                  className="rounded-2xl bg-white p-5 shadow-lg border border-amber-100"
                >
                  <h4 className="text-lg font-bold text-[#014864]">Fee Breakdown</h4>
                  <div className="mt-3 text-sm text-gray-700 grid gap-2">
                    <div className="flex justify-between"><span>Admission Fee (once)</span><span className="font-semibold">16,500 BDT</span></div>
                    <div className="flex justify-between"><span>Application Form Fee</span><span className="font-semibold">500 BDT</span></div>
                    <div className="flex justify-between"><span>Registration Fee (Per Semester)</span><span className="font-semibold">4,000 BDT</span></div>
                    <div className="flex justify-between"><span>Orientation Fee</span><span className="font-semibold">1,000 BDT</span></div>
                    <div className="flex justify-between"><span>Tuition Fee (Per Credit)</span><span className="font-semibold">3,200 BDT</span></div>
                    

                    <div className="border-t pt-2 mt-2 flex justify-between text-amber-900 font-bold"> <span>Total Fee</span><span>5,42,800 BDT</span></div>
                    <div className="flex justify-between text-[#014864] font-semibold"> <span>After Waiver (50%)</span><span>2,96,400 BDT</span></div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            <motion.div layout className="rounded-2xl bg-white p-5 shadow-lg border border-amber-100">
              <h4 className="text-lg font-bold text-[#014864]">Quick Facts</h4>
              <ul className="mt-3 text-sm text-gray-700 list-disc pl-5 space-y-1">
                <li>Total courses: <span className="font-semibold">43</span></li>
                <li>Category :A Humanities & Social Science: <span className="font-semibold">07</span></li>
                <li>Category: B Science, Mathematics and other Engineering <span className="font-semibold">10</span></li>
                <li>Category: C Engineering Compulsory <span className="font-semibold">23</span></li>
                <li>Category: D Engineering Optional: <span className="font-semibold">3</span></li>               
              </ul>
            </motion.div>

            <motion.div layout className="rounded-2xl bg-white p-5 shadow-lg border border-amber-100">
              <h4 className="text-lg font-bold text-[#014864]">Entry Requirements</h4>
              <div className="mt-3 text-sm text-gray-700">
                <p><strong>Local students:</strong> Minimum GPA of 2.5 both in SSC and HSC examinations or equivalent.</p>
                <p className="mt-1"><strong>International students:</strong> A level or completion of international equivalent education.</p>
                <p className="mt-1"><strong>English:</strong> IELTS (Academic) overall 5 (hand score).</p>
              </div>
            </motion.div>
          </div>

          {/* Middle column: description, facilities, assessment */}
          <div className="md:col-span-2 space-y-4">
            <motion.section
              layout
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="rounded-2xl bg-white p-6 shadow-lg border border-amber-100"
            >
              <div className="flex items-start justify-between">
                <div>
                  <h2 className="text-2xl font-extrabold text-amber-900">About the BTE Program</h2>
                  <p className="mt-3 text-gray-700">
					        The Department of Textile Engineering at the University of Creative Technology Chittagong (UCTC) is committed to developing skilled, innovative, and industry-ready textile engineers through comprehensive academic programs, practical training, and research-oriented learning. The program provides students with a strong foundation in textile science, fiber technology, yarn manufacturing, fabric production, wet processing, apparel manufacturing, and textile testing and quality control.

                   With a focus on industrial applications, technological advancement, sustainability, and innovation, the program prepares graduates to meet the evolving needs of Bangladesh's textile and ready-made garments (RMG) industry and the global textile market. Through laboratory work, industrial exposure, collaborative projects, and modern manufacturing practices, students develop the technical knowledge, analytical abilities, and professional skills required to contribute to the growth of the textile and apparel sector.
				  </p>
                  <h3 className="mt-4 text-lg font-bold text-[#014864]">The benefits - on leaving the course - you will have:</h3>
                  <ul className="mt-2 list-disc pl-5 text-gray-700 space-y-1">
                    <li>The ability to understand and apply the principles of textile engineering, including fiber science, yarn manufacturing, fabric formation, dyeing, printing, finishing, and apparel production.</li>
                    <li>The ability to analyze textile manufacturing processes, identify production challenges, and develop effective solutions to improve productivity, efficiency, and product quality.</li>
                    <li>The skills to operate, evaluate, and maintain textile machinery and equipment in accordance with industrial standards and safety requirements.</li>
                    <li>The ability to conduct textile testing, quality assurance, and quality control to ensure compliance with national and international standards.</li>
                    <li>Knowledge of sustainable textile production, environmental management, waste reduction, and the efficient use of energy, water, and raw materials.</li>
                    <li>The ability to apply modern technologies, automation, and digital tools to improve textile manufacturing and supply chain operations.</li>
                   
                  </ul>
                </div>

                <div className="w-48 hidden md:block">
                  <div className="rounded-lg p-4 bg-[#E6FAFE] border border-amber-100">
                    <h4 className="text-sm font-bold text-[#014864]">Course Fact File</h4>
                    <div className="mt-2 text-sm text-gray-700 space-y-1">
                      <div><strong>Degree:</strong> B.Sc in TE</div>
                      <div><strong>Duration:</strong> 4 Years</div>
                      <div><strong>Start Date:</strong> January, July</div>
                      <div><strong>Mode:</strong> Full Time; On Campus</div>
                      <div><strong>Tuition (home):</strong> 5,42,800 BDT</div>
                      <div><strong>International:</strong> 7,000$</div>
                      <div><strong>Scholarship:</strong> Available</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6">
                <h4 className="text-lg font-bold text-[#014864]">Assessment Scheme</h4>
                <div className="mt-3 grid grid-cols-2 md:grid-cols-5 gap-2 text-sm text-gray-700">
                  <div className="p-3 bg-[#E6FAFE] rounded-md text-center"><div className="font-semibold">Class Tests / Presentations</div><div>15</div></div>
                  <div className="p-3 bg-[#E6FAFE] rounded-md text-center"><div className="font-semibold">Attendance</div><div>10</div></div>
                  <div className="p-3 bg-[#E6FAFE] rounded-md text-center"><div className="font-semibold">Viva-voce</div><div>5</div></div>
                  <div className="p-3 bg-[#E6FAFE] rounded-md text-center"><div className="font-semibold">Mid-term Exam</div><div>30</div></div>
                  <div className="p-3 bg-[#E6FAFE] rounded-md text-center"><div className="font-semibold">Final Exam</div><div>40</div></div>
                </div>
              </div>
            </motion.section>

            <motion.section layout className="rounded-2xl bg-white p-6 shadow-lg border border-amber-100">
              <h3 className="text-xl font-bold text-[#014864]">Career Opportunities</h3>
			  <p className="mt-3 text-gray-700">
				The textile and apparel industry offers diverse career opportunities for graduates with a background in textile engineering. As one of the world's major textile and ready-made garment manufacturing countries, Bangladesh provides opportunities for skilled textile engineers to contribute to production, product development, quality assurance, sustainability, and industrial innovation.
				<br/><br/>
				Whether your interest lies in textile manufacturing, fabric development, dyeing and finishing, apparel production, or advanced textile technologies, a degree in Textile Engineering can prepare you for a rewarding professional career. Graduates may pursue opportunities in textile mills, garment factories, buying houses, testing laboratories, research organizations, technical textile industries, and international apparel and fashion companies.
			  </p>
              <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-2 text-sm text-gray-700">
                {[
                  "Textile Production Engineer",
                  "Textile Process Engineer",
                  "Yarn Manufacturing Engineer",
                  "Fabric Manufacturing Engineer",
                  "Dyeing and Finishing Engineer",
                  "Apparel Manufacturing Engineer",
                  "Textile Testing and Quality Control Engineer",     
				          "Quality Assurance Manager",
				          "Textile Merchandiser",
				          "Research and Development Engineer",
				          "Product Development Specialist",
				  "Textile Laboratory and Testing Specialist",
				  
                ].map((c) => (
                  <div key={c} className="p-3 rounded-md bg-[#E6FAFE] text-center">{c}</div>
                ))}
              </div>
            </motion.section>

            {/* Semester/course accordion */}
            <motion.section layout className="rounded-2xl bg-white p-6 shadow-lg border border-amber-100">
              <div className="flex items-center justify-between">
                <h3 className="text-xl font-bold text-[#014864]">Semester-wise Courses</h3>
                <div className="text-sm text-gray-600">{loadingCourses ? "Loading courses..." : "Select semester to view details"}</div>
              </div>

              <div className="mt-4 flex gap-2 overflow-auto pb-2">
                {Object.keys(courses).map((sem) => (
                  <button
                    key={sem}
                    onClick={() => setSelectedSemester(sem)}
                    className={`whitespace-nowrap px-3 py-1 rounded-full border ${selectedSemester === sem ? "bg-amber-700 text-white" : "bg-[#E6FAFE] text-[#014864]"}`}
                  >
                    {sem.replace("Semester Number: ", "Semester ")}
                  </button>
                ))}
              </div>

              <div className="mt-4">
                <table className="w-full text-sm border-collapse">
                  <thead>
                    <tr className="bg-[#E6FAFE]">
                      <th className="p-2 text-left border-b">#</th>
                      <th className="p-2 text-left border-b">Code</th>
                      <th className="p-2 text-left border-b">Title</th>
                      <th className="p-2 text-left border-b">Credit</th>
                      <th className="p-2 text-left border-b">Pre-req</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courses[selectedSemester] && courses[selectedSemester].map((c) => (
                      <tr key={c.course_id} className="hover:bg-[#E6FAFE]">
                        <td className="p-2 align-top border-b">{c.sl}</td>
                        <td className="p-2 align-top border-b font-mono">{c.actual_code}</td>
                        <td className="p-2 align-top border-b">{c.course_title}</td>
                        <td className="p-2 align-top border-b">{c.credit_hours}</td>
                        <td className="p-2 align-top border-b">{c.pre_requisite || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </motion.section>
          </div>
        </div>

        
      </div>
    </div>
	</>
  );
}
